import {
  VIDEO_UPLOAD_CM_FAILURE,
  VIDEO_UPLOAD_CM_REQUEST,
  VIDEO_UPLOAD_CM_RESET,
  VIDEO_UPLOAD_CM_SUCCESS,
} from "../../actions/types";

const initialState = {
  data: {},
  loading: false,
  error: null,
};

const VideoUploadCmReducer = (state = initialState, action) => {
  switch (action.type) {
    case VIDEO_UPLOAD_CM_REQUEST:
      return { ...state, loading: true, error: null };
    case VIDEO_UPLOAD_CM_SUCCESS:
      return { ...state, data: action.payload, loading: false, error: null };
    case VIDEO_UPLOAD_CM_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case VIDEO_UPLOAD_CM_RESET:
      return initialState;
    default:
      return state;
  }
};

export default VideoUploadCmReducer;
